export { default as vuex } from './userProfile.store'
export { default as routes } from './userProfile.routes'
